module.exports = "<% if (!GLOBALS.IS_LAZY_USER) { %>\n  <div class=\"alert mh-alert animated bounceInRight\">\n    <div class=\"icon-lightbulb\"><div>💡</div></div>\n    <div class=\"tip-content\">\n      <span class=\"title\">Moodhacker Tip:</span> Take our\n      <a href=\"#screener-modal-<%= screenerSetItem.get('id') %>\"\n         data-toggle=\"modal\">\n         <%= screenerSetItem.get('screener').name %></a> survey.\n      Get personalized recommendations.\n    </div>\n  </div>\n<% } %>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./web/templates/js/assessment-tip.html
// module id = 153
// module chunks = 0